import { SvgIcon } from '@material-ui/core'

export default function CommunityIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 30 28" fill="none" {...props}>
            <path
                d="M5.98118 15.4635C5.18603 15.4635 4.45431 15.2196 3.85054 14.7985C2.92086 15.1364 2.1771 15.9152 1.91241 16.9182L1.30428 19.1986C1.091 19.9774 1.67833 20.7419 2.48882 20.7419H8.5679C8.14681 20.1545 8.01664 19.4174 8.20368 18.7097L8.90477 16.1011C8.96711 15.8671 9.04477 15.6439 9.1443 15.4263C8.84789 15.1506 8.50008 14.9385 8.11508 14.7974C7.50694 15.2185 6.77413 15.4624 5.97898 15.4624L5.98118 15.4635Z"
                fill="currentColor"
            />
            <path
                d="M5.98247 14.4211C7.49621 14.4211 8.72233 13.1939 8.72233 11.6813C8.72233 10.1675 7.49514 8.94141 5.98247 8.94141C4.46873 8.94141 3.24261 10.1686 3.24261 11.6813C3.24261 13.195 4.4698 14.4211 5.98247 14.4211Z"
                fill="currentColor"
            />
            <path
                d="M27.8192 19.1975L27.2056 16.917C26.9409 15.9141 26.1971 15.1353 25.2674 14.7974C24.6648 15.2185 23.932 15.4624 23.1368 15.4624C22.3416 15.4624 21.6099 15.2185 21.0007 14.7974C20.6212 14.9374 20.2734 15.1506 19.977 15.4263C20.0754 15.6439 20.1542 15.8681 20.2165 16.1011L20.9122 18.7097C21.0992 19.4163 20.969 20.1535 20.5534 20.7419H26.6269C27.4374 20.7419 28.0247 19.9785 27.8169 19.1986L27.8192 19.1975Z"
                fill="currentColor"
            />
            <path
                d="M25.876 11.6813C25.876 13.195 24.6499 14.4222 23.1361 14.4222C21.6223 14.4222 20.3962 13.195 20.3962 11.6813C20.3962 10.1686 21.6223 8.94141 23.1361 8.94141C24.6499 8.94141 25.876 10.1686 25.876 11.6813Z"
                fill="currentColor"
            />
            <path
                d="M19.209 16.3691C18.8875 15.1638 17.9676 14.2439 16.8192 13.8906C16.1695 14.3161 15.3951 14.5611 14.5595 14.5611C13.7228 14.5611 12.9484 14.3172 12.2998 13.8906C11.1513 14.2439 10.2315 15.1638 9.90994 16.3691L9.20885 18.9777C8.96931 19.8713 9.64525 20.7441 10.5651 20.7441H18.556C19.4759 20.7441 20.1507 19.8713 19.9123 18.9777L19.2112 16.3691H19.209Z"
                fill="currentColor"
            />
            <path
                d="M14.5601 13.5158C16.2904 13.5158 17.6928 12.1136 17.6928 10.3831C17.6928 8.6539 16.2906 7.25049 14.5601 7.25049C12.8298 7.25049 11.4275 8.65267 11.4275 10.3831C11.4275 12.1134 12.8297 13.5158 14.5601 13.5158Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
